import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { AssetsCatagoryDto } from '.';




export class AssetsCatagoryResponse extends GlobalResponseObject {
    data?: AssetsCatagoryDto;
    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: AssetsCatagoryDto) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}
